module.exports = __webpack_public_path__ + "static/img/service_safeguard_icon_1.a6aa8831.svg";